import { render, staticRenderFns } from "./Setups.vue?vue&type=template&id=7bdc05fe&"
import script from "./Setups.vue?vue&type=script&lang=js&"
export * from "./Setups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3358805848/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bdc05fe')) {
      api.createRecord('7bdc05fe', component.options)
    } else {
      api.reload('7bdc05fe', component.options)
    }
    module.hot.accept("./Setups.vue?vue&type=template&id=7bdc05fe&", function () {
      api.rerender('7bdc05fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/History/Setups.vue"
export default component.exports